<div class="container">
  <div class="newRow" style="min-height: 400px">
    <h2 style="text-align: center;line-height: 400px;">Нет доступа!</h2>
    <p>
      <a class="btn" routerLink="/sales">На главную!</a>
    </p>
  </div>
</div>
